import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';

import enTranslation from './en.json';

const resources = {
  en: {
    translation: enTranslation,
  },
};

i18n
  .use(initReactI18next)
  .init({
    interpolation: {
      escapeValue: false
    },
    resources,
    lng: 'en'
  });

export default i18n;